export default {"src":"/_next/static/media/POTX.140f0564.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};